import React from "react";
import { RiskyTroves } from "../components/RiskyTroves";

export const RiskyTrovesPage: React.FC = () => (
  <div className="w-full">
    <div className="text-style-title mt-4">
      Risky Troves
    </div>
    <RiskyTroves pageSize={10} />
  </div>
);
